import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import MobileModal from 'components/consumer/MobileModal';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const PushAcrossSidebar = t0 => {
  const $ = _c(38);
  const {
    children,
    desktopFilterSize: t1,
    isFullHeight: t2,
    isMaterialSwatch: t3,
    isOpen,
    isPhotoModalOpen: t4,
    mobileClassName: t5,
    mobileContentUnderHeader,
    mobileHeaderRight,
    mobileHeaderRightClassName: t6,
    mobileHideHeader: t7,
    mobileContentNoPadding,
    mobileOnClose,
    mobileTitle,
    mobileVariant,
    stickyRef,
    variant
  } = t0;
  const desktopFilterSize = t1 === undefined ? 0 : t1;
  const isFullHeight = t2 === undefined ? false : t2;
  const isMaterialSwatch = t3 === undefined ? false : t3;
  const isPhotoModalOpen = t4 === undefined ? false : t4;
  const mobileClassName = t5 === undefined ? "" : t5;
  const mobileHeaderRightClassName = t6 === undefined ? "" : t6;
  const mobileHideHeader = t7 === undefined ? false : t7;
  const {
    isMobileOrTablet,
    windowWidth
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  useOnEsc(isOpen, mobileOnClose);
  useTrapFocus(isOpen, modalRef);
  const isFabricGrid = variant === "fabric-grid";
  if (isMobileOrTablet) {
    let t8;
    if ($[0] !== children || $[1] !== isMaterialSwatch || $[2] !== isOpen || $[3] !== mobileClassName || $[4] !== mobileContentNoPadding || $[5] !== mobileContentUnderHeader || $[6] !== mobileHeaderRight || $[7] !== mobileHeaderRightClassName || $[8] !== mobileHideHeader || $[9] !== mobileOnClose || $[10] !== mobileTitle || $[11] !== mobileVariant) {
      t8 = <MobileModal className={mobileClassName} closeIcon="arrow" contentNoPadding={mobileContentNoPadding} contentUnderHeader={mobileContentUnderHeader} enableHashHistory={false} headerCenter={mobileTitle} headerRight={mobileHeaderRight} headerRightClassName={mobileHeaderRightClassName} hideHeader={mobileHideHeader} isFullHeight={true} isMaterialSwatch={isMaterialSwatch} isOpen={isOpen} onClose={mobileOnClose} variant={mobileVariant}>{children}</MobileModal>;
      $[0] = children;
      $[1] = isMaterialSwatch;
      $[2] = isOpen;
      $[3] = mobileClassName;
      $[4] = mobileContentNoPadding;
      $[5] = mobileContentUnderHeader;
      $[6] = mobileHeaderRight;
      $[7] = mobileHeaderRightClassName;
      $[8] = mobileHideHeader;
      $[9] = mobileOnClose;
      $[10] = mobileTitle;
      $[11] = mobileVariant;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  const t8 = !isOpen;
  let t9;
  if ($[13] !== isFabricGrid || $[14] !== isOpen || $[15] !== t8) {
    t9 = classNames("md:w-[var(--push-across-sidebar-current-width)]", "bg-white [border-left:1px_solid_#dbdbdb] bottom-0 absolute right-0 top-0 max-[767px]:h-screen", "max-[767px]:left-0 max-[767px]:fixed max-[767px]:right-0 max-[767px]:top-0", {
      hidden: t8,
      block: isOpen,
      "md:border-0": isFabricGrid
    });
    $[13] = isFabricGrid;
    $[14] = isOpen;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = !!isPhotoModalOpen;
  const t11 = isFabricGrid && !!isPhotoModalOpen;
  let t12;
  if ($[17] !== isFabricGrid || $[18] !== t10 || $[19] !== t11) {
    t12 = classNames("h-screen max-h-screen overflow-x-hidden relative overflow-y-auto md:overflow-y-auto md:sticky md:max-h-[calc(100vh_-_55px)] md:top-[55px] [&::-webkit-scrollbar]:hidden", {
      "md:right-0": isFabricGrid,
      PushAcrossSidebar__photo: t10,
      "md:z-30": t11
    });
    $[17] = isFabricGrid;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = windowWidth !== 768 ? `${desktopFilterSize + 55}px` : 0;
  let t14;
  if ($[21] !== t13) {
    t14 = {
      top: t13
    };
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = isFullHeight && isOpen;
  let t16;
  if ($[23] !== isFabricGrid || $[24] !== t15) {
    t16 = classNames("w-[var(--push-across-sidebar-open-width)] max-[767px]:pb-[78px]", {
      "md:min-h-screen": t15,
      "md:bg-white": isFabricGrid
    });
    $[23] = isFabricGrid;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== children || $[27] !== t16) {
    t17 = <div className={t16}>{children}</div>;
    $[26] = children;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== stickyRef || $[30] !== t12 || $[31] !== t14 || $[32] !== t17) {
    t18 = <div className={t12} ref={stickyRef} style={t14} data-xc="PushAcrossSidebar__sticky">{t17}</div>;
    $[29] = stickyRef;
    $[30] = t12;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== modalRef || $[35] !== t18 || $[36] !== t9) {
    t19 = <div ref={modalRef} className={t9} data-xc="PushAcrossSidebar">{t18}</div>;
    $[34] = modalRef;
    $[35] = t18;
    $[36] = t9;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
};
PushAcrossSidebar.propTypes = {
  children: PropTypes.node.isRequired,
  desktopFilterSize: PropTypes.number,
  isFullHeight: PropTypes.bool,
  isMaterialSwatch: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  isPhotoModalOpen: PropTypes.bool,
  mobileClassName: PropTypes.string,
  mobileContentNoPadding: PropTypes.bool,
  mobileContentUnderHeader: PropTypes.bool,
  mobileHeaderRight: PropTypes.node,
  mobileHeaderRightClassName: PropTypes.string,
  mobileHideHeader: PropTypes.bool,
  mobileOnClose: PropTypes.func.isRequired,
  mobileTitle: PropTypes.node,
  mobileVariant: PropTypes.string,
  stickyRef: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['fabric-grid'])
};
export default withBrowserOnly(PushAcrossSidebar);